import { ValidationProvider, ValidationService } from "aspnet-client-validation";

//NOTE: This must match up with the server-side implementation!

/** The 'must be true' provider name */
export const PROVIDER_NAME: string = "filesize";

/**
 * Adds the 'must be true' provider to the validation service
 * @param validation The validation service
 */
export function addFileSizeProvider(validation: ValidationService)
{
    validation.addProvider(PROVIDER_NAME, provider);
}

/**
 * A validation provider that validates that a boolean must be true
 */
export const provider: ValidationProvider = (value, element, params) =>
{
    const maxFileSize: number = +params["max"];

    if (element instanceof HTMLInputElement)
    {
        if (element.files == null || element.files.length === 0)
            return true; //Let [Required] handle empty input first

        for (const file of element.files)
        {
            if (file.size > maxFileSize)
                return false; //Use the server-provided default error message
        }

        return true;
    }
    else
    {
        return "Invalid input element";
    }
};
